export default __webpack_public_path__ + "static/media/JAS0150.34I-43218_-25840_0.c7ed2c96.jpg";